import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { EnvironmentService } from './environment.service';

export const DevelopmentGuard: CanActivateFn = (): boolean => {
  return inject(EnvironmentService).type() !== 'prod';
};
